import { ArticleCategory, ArticleType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { numberToString, requiredString, requiredStringToNumber } from '@/utils/zodUtils';

export const MinimalFormItemSchema = (t: GetTextIdTranslationType) =>
  z.object({
    units: requiredStringToNumber(t)
      .pipe(z.number().min(1, { message: t('AT_LEAST_ONE_UNIT_ERROR') }))
      .transform(numberToString),
    description: requiredString(t),
    vat: requiredStringToNumber(t)
      .pipe(
        z
          .number()
          .min(0, { message: t('INVALID_NEGATIVE_PERCENTAGE') })
          .refine((val) => val <= 100, { message: t('INVALID_PERCENTAGE') }),
      )
      .transform(numberToString),
    price: requiredStringToNumber(t)
      .refine((val) => val !== 0, { message: t('AMOUNT_NOT_ZERO') })
      .transform(numberToString),

    type: z.nativeEnum(ArticleType),
    category: z.nativeEnum(ArticleCategory),
  });
